import React from "react";
import type { RichTextBlock } from "../../../types/content";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import styles from "./RichText.module.css";

export interface RichTextProps {
  /**
   * The rich text block data from Umbraco
   */
  block: RichTextBlock;

  /**
   * Optional CSS class name
   */
  className?: string;
}

/**
 * Rich Text component
 * Renders HTML content from a rich text editor
 */
export const RichText: React.FC<RichTextProps> = ({ block, className }) => {
  const { text } = block;

  if (!text) {
    return null;
  }

  const containerClasses = [styles.richText, className]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={containerClasses} data-component="rich-text">
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
      />
    </section>
  );
};

export default RichText;
